export default __webpack_public_path__ + "static/media/edge-double-serrate.bdb539b3.PNG";